import { Divider, List, Skeleton } from "antd";
import React, {
  ReactElement,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from "react";
import InfiniteScroll from "react-infinite-scroll-component";


interface ScrollableLoadMoreProps {
  loadMoreData: () => void; // Assuming loadMoreData is a function with no arguments and no return value
  items: any[];
  itemComponent: React.ComponentType<{ item: any }>; // Changed to ComponentType
  inverse?:boolean,
  endMessage?: string
  bgColor?:string
  endOfListReached: boolean
  extraProps?: Record<string, any>;
  loader?: React.ReactNode;
}

const ScrollableLoadMore: React.FC<ScrollableLoadMoreProps> = ({
  loadMoreData,
  bgColor = '#fff',
  items,
  itemComponent,
  inverse = false,
  endOfListReached,
  endMessage = "End of list",
  extraProps = {},
  loader
}) => {

  const defaultLoader = (
    <>
      <Skeleton.Node style={{width: '100%', height: '46px', margin: '2px 2px'}} active />
      <Skeleton.Node style={{width: '100%', height: '46px', margin: '2px 2px'}} active />
      <Skeleton.Node style={{width: '100%', height: '46px', margin: '2px 2px'}} active />
    </>
  );


  useEffect(()=>{
    // console.log("END OF LIST VALUE CHANGE",endOfListReached)
  },[endOfListReached])

  const scrollableDivRef = useRef<any>(null);

  const scrollableAreaEventCaptureFix = () => {
    scrollableDivRef.current.addEventListener(
      "scroll",
      (event: React.UIEvent<HTMLDivElement, UIEvent>) => {
        const target = event.currentTarget || this;

        if (
          !(
            (event as unknown as CustomEvent)?.detail?.source ===
            "customScrollHandler"
          )
        ) {
          event.stopPropagation();

          // Create a new event with the same properties as the original
          const newEvent = new CustomEvent("scroll", {
            bubbles: true,
            cancelable: true,
            composed: true, // Ensure the event crosses shadow boundaries if needed
            detail: {
              source: "customScrollHandler",
            },
          });

          // Use the new target
          Object.defineProperty(newEvent, "target", {
            value: target,
            configurable: true,
          });

          // Dispatch the custom event
          scrollableDivRef.current?.dispatchEvent(newEvent);
        }
      },
      true
    ); // Use true to enable capturing phase
  };

  useEffect(() => {
    scrollableAreaEventCaptureFix();
  }, []);

  return (
    <div
      ref={scrollableDivRef}
      className="scrollableListDiv"
      style={{
        overflowX: "hidden",
        overflowY: "scroll",
        // width: "1px",
        background: bgColor,
        border: "0 1px solid #eee",
        
        // marginTop: "5px",
        display:'flex',
        flexDirection: inverse? 'column-reverse':'column'
      }}
    >
      {scrollableDivRef.current && (
 
        <InfiniteScroll
          inverse={inverse}
          dataLength={items.length}
          next={loadMoreData}
          hasMore={!endOfListReached}
          loader={loader || defaultLoader}
          endMessage={<Divider plain>{items.length? endMessage : 'None Found'}</Divider>}
          scrollableTarget={scrollableDivRef.current}
          style={{
            overflowX: "hidden",
            overflowY: "scroll",
            display:'flex',
            flexDirection: inverse? 'column-reverse' : 'column'
          }}
        >
          <List
            rowKey={(item) => item.contact_id || item.id || item.email} // Use contact_id as primary key
            locale={{ emptyText: null }}
            dataSource={items}
            renderItem={(item) => React.createElement(itemComponent, { item, ...extraProps })}
          />
        </InfiniteScroll>
      )}
    </div>
  );
};

export default ScrollableLoadMore;
